module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "cb-section cb-bar"
  }, [_c('cb-slide-n-fade', {
    attrs: {
      "isList": true,
      "is-list": true,
      "timeOut": true,
      "reCalculateMargin": true
    }
  }, _vm._l((_vm.childSubDataDisplayList), function(item, index) {
    return ((!_vm.childSubLimit || index < _vm.childSubLimit)) ? _c('div', {
      directives: [{
        name: "cb-link",
        rawName: "v-cb-link",
        value: ('shadow'),
        expression: "'shadow'"
      }],
      key: index,
      staticClass: "cb-bar__wrap",
      class: {
        'cb-bar__wrap--noborder': index == _vm.limit - 1 && _vm.childSubLimit && _vm.childSubDataDisplayList.length >= _vm.childSubLimit
      },
      attrs: {
        "role": "navigation",
        "data-cb-id": "child_subscription_details"
      },
      on: {
        "click": function($event) {
          _vm.navigate_to('child_sub_details', {
            params: {
              subscriptionId: item.id
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "cb-mar--b-xs"
    }, [_c('i', {
      staticClass: "icon-parent-child",
      style: (_vm.themeColor)
    }), _vm._v(" "), _c('span', {
      staticClass: "cb-bar__label cb-bar__middle"
    }, [_vm._v(_vm._s(_vm.getChild(item.subscription.customer_id)))])]), _vm._v(" "), (!item.hide_plan) ? _c('div', {
      staticClass: "cb-bar__title"
    }, [(item.gift_id) ? _c('span', [_c('i', {
      staticClass: "icon-gift",
      style: (_vm.themeColor)
    })]) : _vm._e(), _vm._v(" "), (item.state == 'cancelled') ? _c('span', {
      staticClass: "cb-bar__flag"
    }, [_vm._v(_vm._s(_vm.st('subscription_status.canceled')))]) : _vm._e(), _vm._v(" "), (item.state == 'paused') ? _c('span', {
      staticClass: "cb-bar__flag"
    }, [_vm._v(_vm._s(_vm.st('subscription_status.paused')))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "cb-bar__middle"
    }, [_vm._v(_vm._s(item.plan_name))]), _vm._v(" "), (item.plan_quantity > 1) ? _c('span', {
      staticClass: "cb-bar__middle"
    }, [_vm._v("× " + _vm._s(item.plan_quantity))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.addons && item.addons.length > 0) ? _vm._l((item.addons), function(addon, index) {
      return (index < 1) ? _c('div', {
        key: index,
        staticClass: "cb-bar__title"
      }, [(item.hide_plan) ? [(item.hide_plan && item.state == 'paused') ? _c('span', {
        staticClass: "cb-bar__flag"
      }, [_vm._v(_vm._s(_vm.st('subscription_status.paused')))]) : _vm._e(), _vm._v(" "), (item.hide_plan && item.state == 'cancelled') ? _c('span', {
        staticClass: "cb-bar__flag"
      }, [_vm._v(_vm._s(_vm.st('subscription_status.canceled')))]) : _vm._e()] : _vm._e(), _vm._v("\n            " + _vm._s(addon.details.invoice_name || addon.details.name) + "\n            "), (addon.quantity > 1) ? _c('span', [_vm._v("× " + _vm._s(addon.quantity))]) : _vm._e()], 2) : _vm._e()
    }) : _vm._e(), _vm._v(" "), (item.addons && item.addons.length > 1) ? _c('div', [_vm._v("+" + _vm._s(item.addons.length - 1) + " " + _vm._s(_vm.getMoreItemTxt()))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cb-bar__content"
    }, [_c('span', {
      staticClass: "cb-bar__price"
    }, [_vm._v(_vm._s(_vm._f("cbCurrency")(item.recurring_price, item.currency_code)))]), _vm._v(" "), (!item.gift_id && _vm.billingText(item)) ? _c('span', {
      staticClass: "cb-bar__desc"
    }, [_vm._v(_vm._s(_vm.billingText(item)))]) : _vm._e(), _vm._v(" "), (_vm.additionalSummaryInfo(item)) ? _c('div', {
      directives: [{
        name: "cb-html",
        rawName: "v-cb-html",
        value: (_vm.additionalSummaryInfo(item)),
        expression: "additionalSummaryInfo(item)"
      }],
      staticClass: "cb-truncate"
    }) : _vm._e()])], 2) : _vm._e()
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ce6432b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/portal/PortalChildSubTemplateCommon.vue
// module id = 601
// module chunks = 66